import { Component, OnInit } from "@angular/core";
import { locale as italian } from "../../../../../i18n/it";
import { BargainingService } from "../../bargaining.service";
import { UtilsService } from "../../../../../auth/service/utils.service";
import { Router } from "@angular/router";
import { AuthenticationService } from "../../../../../auth/service";
import { CandidateService } from "../../../candidates/candidate.service";
import moment from "moment";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { CustomerService } from "../../../../customer/customer.service";
import { filter } from "rxjs/operators";

@Component({
  selector: "app-bargaining-list",
  templateUrl: "./bargaining-list.component.html",
})
export class BargainingListComponent implements OnInit {
  public filter_status: number = -1;
  public filter_string: string = "";
  public tableLimit: number = 10;
  public filtered_list: any = [];
  public contentHeader: IContentHeader = null;
  public statusRequestLabels: any = [];
  public statusSendLabels: any = [];
  public barganingList: any = [];
  public today: any = moment().format("DD/MM/YYYY");

  commercialList: string[] = [];
  filterCommercial: string = "";

  constructor(
    public customerService: CustomerService,
    public bargainingService: BargainingService,
    public _utilService: UtilsService,
    public router: Router,
    public _authenticationService: AuthenticationService,
    public _candidateService: CandidateService,
  ) {
    this._utilService.disableAutoHideLoading();
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("show_menu_bargaining_list")) {
      this._utilService.hideLoading();
      this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    await this.loadBargaining();
    await this.search();
    await this._utilService.translate("IN_PROGRESS").then((item: string) => this.statusRequestLabels.push(item));
    await this._utilService.translate("COMPLETE").then((item: string) => this.statusRequestLabels.push(item));
    await this._utilService.translate("DISABLED").then((item: string) => this.statusRequestLabels.push(item));

    await this._utilService.translate("NOT_SENDED").then((item: string) => this.statusSendLabels.push(item));
    await this._utilService.translate("SENDED").then((item: string) => this.statusSendLabels.push(item));
    await this._utilService.translate("TO_APPROVED").then((item: string) => this.statusSendLabels.push(item));
    await this._utilService.translate("APPROVED_MALE_PLURAL").then((item: string) => this.statusSendLabels.push(item));
    await this._utilService.translate("NOT_APPROVED_PLURAL_MALE").then((item: string) => this.statusSendLabels.push(item));

    this.contentHeader = {
      headerTitle: italian.data.MENU.BARGAINING,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.RECRUITMENT,
            isLink: false,
          },
          {
            name: italian.data.MENU.BARGAINING,
            isLink: false,
          },
        ],
      },
    };
    this._utilService.hideLoading();
  }

  async loadBargaining() {
    this.barganingList = await this.bargainingService.getBargainings();
    this.barganingList.map((item: any) => {
      item.status_document = item.status_document || 0;
      item.status_contract = item.status_contract || 0;
    });
    this.barganingList.map((item: any) => {
      if(!this.commercialList.find((commercial: any) => commercial === item.commercial.complete_name)) {
        this.commercialList.push(item.commercial.complete_name);
      }
    })
    //Controllo che ci siano contrattazioni attive e setto lo stato della select su quelle attive, se no su tutte
    const bargainingActivatedList: any = this.barganingList.filter((item: any) => item.status === 0).length;
    if (bargainingActivatedList > 0) {
      this.filter_status = 0;
    } else {
      this.filter_status = -1;
    }
    setTimeout(() => this._utilService.hideLoading());
  }

  async search() {
    const keyword: string = this.filter_string.toLowerCase().trim();
    let list: any = this.barganingList;
    if (keyword.length > 0) {
      list = list.filter((item: any) => {
        const includeTitle = item?.request_name?.toLowerCase().includes(keyword);
        const includeCompleteName = item?.user?.complete_name?.toLowerCase().includes(keyword);
        let includeCommericalName = includeTitle && includeCompleteName;
        if (!!item.commercial && !!item.commercial.complete_name) {
          includeCommericalName = item?.commercial?.complete_name?.toLowerCase().includes(keyword);
        }
        return includeTitle || includeCompleteName || includeCommericalName;
      });
    }
    if (this.filter_status > -1) {
      list = list.filter((item: any) => Number(item.status) === Number(this.filter_status));
    }
    if(this.filterCommercial && this.filterCommercial.length > 0) {
      list = list.filter((item: any) => item.commercial.complete_name === this.filterCommercial);
    }
    this.filtered_list = list;
  }

  async deleteBargaining(idBargaining: number) {
    if (!this._authenticationService.hasCapability("delete_bargaining")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");

    await this._utilService.showSWALDeleteConfirmation({ text: deleteText }).then(async (result) => {
      if (result.value) {
        await this.bargainingService
          .deleteBargaining(idBargaining)
          .then(async () => {
            await this._utilService.showPopupItemDeleted();
            this.barganingList = this.barganingList.filter((item: any) => {
              return item.id != idBargaining;
            });
            await this.search();
          })
          .catch(async () => {
            await this._utilService.showToastrError("ERROR_REMOVE_BARGAINING");
          });
      } else if (result.isDismissed) {
        await this._utilService.showSWALError({
          title: "ABORTED_TITLE",
          text: "ABORTED_TEXT",
        });
      }
    });
  }

  async restoreBargaining(idBargaining) {
    if (!this._authenticationService.hasCapability("edit_bargaining")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    // popup
    await this._utilService
      .showSWAL({
        title: "CONFIRM_RESTORE_TITLE",
        icon: "warning",
        confirmButtonText: "CONFIRM_RESTORE_BTN",
        customClass: {
          confirmButton: "btn btn-success",
        },
      })
      .then(async (result) => {
        if (result.value) {
          await this.bargainingService
            .updateBargainingStatus(idBargaining, { status: 1 })
            // controllare i testi
            .then(async () => {
              await this.loadBargaining();
              await this.search();
              await this._utilService.showToastrSuccess("SUCCESS_RESTORE_BARGAINING");
            })
            .catch(() => this._utilService.showToastrError("ERROR_RESTORE_BARGAINING"));
        }
      });
  }

  async requestDocumentMasterData(currentBargaining: any) {
    if (!this._authenticationService.hasCapability("edit_bargaining")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    this._utilService.showLoading();
    await this._candidateService
      .requestMasterData(currentBargaining.user.hash)
      .then(async () => {
        this._utilService.hideLoading();
        currentBargaining.status_document = 1;
        await this._utilService.showToastrSuccess("MASTERDATA_SENDED");
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showToastrError("MASTERDATA_SENDED_ERROR");
      });
  }

  async requestDocumentContract(currentBargaining: any) {
    if (!this._authenticationService.hasCapability("edit_bargaining")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    this._utilService.showLoading();
    await this._candidateService
      .requestSignContract(currentBargaining.user.hash)
      .then(async () => {
        this._utilService.hideLoading();
        currentBargaining.status_contract = 1;
        await this._utilService.showToastrSuccess("SUCCESS_REQUEST_CONTRACT_DOCUMENT");
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showToastrError("ERROR_REQUEST_CONTRACT_DOCUMENT");
      });
  }

  protected readonly filter = filter;
  protected readonly sea = module
}
